export const PAGE = {
  COTTO: '100207768987988',
  TRUEIDTEST: '109674367070653',
  TRUEID: '1858940081055826',
  YASALE: '100701258941039',
  THAILANDPOSTMARTTEST: '115414076948160',
  POWERBUY_MAIN_PAGE: '105046831863695',
  POWERBUY_SHOP_SERVICES: [
    'L1656221467',
    'L1656909148',
    '301460564518350',
    '106229284674746',
    '105344925152387'
  ],
  AIRA_AIFUL: ['1637674519806774', '105017609020919'],
  GPF_BUDDY: ['103823529112921'],
  JUZMATCH_SALE: ['113282044961669', '100550751524009'],
  JUZMATCH_SALE_TEST: ['113282044961669'],
  JUZMATCH_CRM: ['104662695835182', '126479423686694'],
  JUZMATCH_CRM_TEST: ['104662695835182'],
  TREMENDOUS: ['111766474864711', '354477511648995'],
  ROOTS: ['104808655743823', '353174701482518'],
  TCP: ['252460531281704'],
  DDPROPERTY: ['100431629788747', '116834751506926'],
  AIRA: ['116450951440611', '368366243260849'],
  TCP_MAIN_PAGE: ['111301538678718', '106378945313542'],
  TCP_SHOP_SERVICES: [
    '101536496332228',
    '110406068769385',
    '104152609400717',
    '101236219696124',
    '116908048108889',
    '117855651346123',
    '112625705212742',
    '113384421800781',
    '115567481582677',
    '109272465563413',
    '165390986804835',
    '106699346035522',
    '649066842180929',
    '118926511456194',
    '399345200114928',
    '144080440883',
    '114646638621839',
    '106668880896781',
    '106818062395292',
    '107107852331881'
  ],
  ASSET_WISE: ['110703175198388', '133607483169551'],
  RATCHTHANI: ['108875962319819', '136075429577683'],
  MORDEE: ['105245498447843'],
  DR_MEK: ['188924694302990', '119890184543994', '1277842645636317', '381410605695545'],
  TOA_MEGA_PAINT: ['232334833287561', '337421534322225'],
  GENERALI_TEST: ['1040247792841569 '],
  DELTA: ['172169405974024'],
  MTC: ['107879035335045', '1688468514708248'],
  TIGERPOLY: ['247498961787606'],
  COMMU_TEST: ['212669041930795']
}



// WEBPACK FOOTER //
// ./src/constants/page.js